import imageLeft from "../assets/left-financial.svg";
import imageRight from "../assets/right-financial.svg";
import logo from "../assets/Logo.png";

export function BackgroundBase() {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none select-none">
      <img src={logo} alt="logo" className="mt-8 ml-4 w-32 sm:w-40" />
      <img
        src={imageLeft}
        alt="left-financial"
        className="hidden lg:block absolute bottom-0 left-0 w-[30rem]"
      />
      <img
        src={imageRight}
        alt="right-financial"
        className="hidden lg:block absolute bottom-0 right-0 w-[30rem]"
      />
    </div>
  );
}
